import React, { useEffect, useState } from "react";

import { useNewGlobalSearch } from "pages/[tenant]/search/hooks/useNewGlobalSearch";

import { XIcon } from "shared/assets/icons/XIcon";
import SimpleUserInitialsName from "shared/components/atoms/SimpleUserInitials";

import { TagCardContainer } from "./styles";

const TagCard = ({ tag }) => {
  const {
    selectedTags,
    setSelectedTags,
    selectedAuthors,
    setSelectedAuthors,
    filterByTags,
    filterByAuthors,
  } = useNewGlobalSearch();
  const [failedToLoadImage, setFailedToLoadImage] = useState(false);

  const [tagsLength, setTagsLength] = useState(selectedTags?.length);
  const [authorsLength, setAuthorsLength] = useState(selectedTags?.length);

  const isAuthor = !!tag?.email;

  const handleRemoveSelectedTag = () => {
    setSelectedTags((prev) => prev?.filter((item) => item?.id !== tag?.id));
    setTagsLength(tagsLength - 1);
  };

  const handleRemoveSelectedAuthor = () => {
    setSelectedAuthors((prev) => prev?.filter((item) => item?.id !== tag?.id));
    setAuthorsLength(authorsLength - 1);
  };

  useEffect(() => {
    if (tagsLength != selectedTags?.length) {
      filterByTags();
    }
  }, [selectedTags]);

  useEffect(() => {
    if (authorsLength != selectedTags?.length) {
      filterByAuthors();
    }
  }, [selectedAuthors]);

  return (
    <TagCardContainer>
      {isAuthor ? (
        <div className="user-infos">
          {tag?.avatar || failedToLoadImage ? (
            <img
              className="userPhoto"
              src={tag?.avatar}
              alt="Foto do usuário"
              onError={() => setFailedToLoadImage(true)}
            />
          ) : (
            <div className="user-initial">
              <SimpleUserInitialsName fullName={tag?.name} smallFormat />
            </div>
          )}
          <div className="user-text-infos">
            <div className="userName">{tag?.name}</div>
            <div
              className="x-icon"
              onClick={() => handleRemoveSelectedAuthor()}
              role="button"
            >
              <XIcon />
            </div>
          </div>
        </div>
      ) : (
        <>
          <p>
            {tag?.label} : {tag?.category?.label}
          </p>
          <div
            className="x-icon"
            onClick={() => handleRemoveSelectedTag()}
            role="button"
          >
            <XIcon />
          </div>
        </>
      )}
    </TagCardContainer>
  );
};

export default TagCard;
